import { Box, Link } from '@mui/material';
import { dashboardFooterStyles, dashboardFooterTextStyles } from './styles';

export function DashboardLayoutFooter(): React.JSX.Element {
  return (
    <Box sx={dashboardFooterStyles}>
      <Link href="https://wavedigital.com.au" underline="none" sx={dashboardFooterTextStyles}>Designed by Wave Digital</Link>
    </Box>);
}
